<template>
    <section class="home-sec2">
        <h2 class="title">برخی از برندهایی که به آن کلیک اعتماد کرده اند:</h2>
        <swiper class="brand-swiper" :modules="modules" :slides-per-view="9" :space-between="22" :loop="true" :autoplay="{
            delay: 2000,
            disableOnInteraction: false,
        }" :allow-touch-move="false" :breakpoints="{
            0: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 5,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 7,
                spaceBetween: 14,
            },
            1230: {
                slidesPerView: 9,
                spaceBetween: 22,
            }
        }">
            <swiper-slide v-for="(image, index) in brandImages" :key="index" class="slide">
                <img :src="image.src" :alt="image.alt">
            </swiper-slide>
        </swiper>
    </section>
</template>

<script>
import { Autoplay } from 'swiper/modules';
export default {
    name: "HomeSection2",
    setup() {
        const brandImages = [
            { src: require('../assets/images/Rectangle 3.png'), alt: 'snapp' },
            { src: require('../assets/images/Rectangle 7.png'), alt: 'khanomi' },
            { src: require('../assets/images/Rectangle 5.png'), alt: 'digikala' },
            { src: require('../assets/images/Rectangle 8.png'), alt: 'blubank' },
            { src: require('../assets/images/Rectangle 4.png'), alt: 'classino' },
            { src: require('../assets/images/Rectangle 9.png'), alt: 'asiatech' },
            { src: require('../assets/images/Rectangle 6.png'), alt: 'technolife' },
            { src: require('../assets/images/Rectangle 11.png'), alt: 'flytoday' },
            { src: require('../assets/images/Rectangle 10.png'), alt: 'lg' }
        ];

        return {
            modules: [Autoplay],
            brandImages
        };
    },
};
</script>

<style scoped>
.home-sec2 {
    margin-inline: 12.58%;
    width: calc(100% - 25.16%);
}

.title {
    font-size: 24px;
    margin-bottom: 22px;
}

.brand-swiper {
    user-select: none;
    margin: auto;
    padding: 15px;
}

.brand-swiper,
.slide img {
    width: 100%;
}

.slide {
    display: flex;
    justify-content: center;
    align-items: center;
}

.slide img {
    object-fit: contain;
    height: auto;
    max-width: 140px;
    max-height: 120px;
    border-radius: 20px;
    box-shadow: 0px 0px 10px var(--shadow-light);
    backdrop-filter: blur(20px);
    background-color: var(--glass-morphism);
}

@media screen and (min-width: 1921px) {
    .home-sec2 {
        width: 1437px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1440px) {
    .title {
        font-size: 20px;
    }
}

@media screen and (max-width: 1230px) {
    .home-sec2 {
        margin-inline: 11.08%;
        width: calc(100% - 22.16%);
    }

    .slide img {
        max-width: 100px;
        max-height: 90px;
    }

    .title {
        font-size: 16px;
    }
}

@media screen and (max-width: 1024px) {
    .home-sec2 {
        margin-inline: 10.306%;
        width: calc(100% - 20.612%);
    }
}

@media screen and (max-width: 768px) {
    .home-sec2 {
        margin-inline: 9.306%;
        width: calc(100% - 18.612%);
    }

    .slide img {
        max-width: 70px;
        max-height: 60px;
        border-radius: 10px;
    }
}

@media screen and (max-width: 360px) {
    .home-sec2 {
        margin-inline: 8.334%;
        width: calc(100% - 16.668%);
    }

    .title {
        font-size: 14px;
        margin-bottom: 14px;
    }
}
</style>